export function parseBrlAmount(value: string): number | null | undefined {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const normalized = trimmed.includes(",")
    ? (/^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$/.test(trimmed) || /^\d+(?:,\d{1,2})?$/.test(trimmed)
      ? trimmed.replace(/\./g, "").replace(",", ".")
      : null)
    : /^\d+(?:\.\d{1,2})?$/.test(trimmed) ? trimmed : null;

  if (!normalized) return undefined;
  const amount = Number(normalized);
  return Number.isFinite(amount) && amount >= 0 ? amount : undefined;
}
